import { ValidationErrorText } from "@vega-core/components/Form/Layout/ValidationError";
import { isTruthy } from "@vega-core/utils/isTruthy";

import { OtpDigit } from "./components/OtpDigit";
import { useOtpInput } from "./useOtpInput";

export type OtpFieldProps = {
  error?: string;
  onChange?: (value: string) => void;
  value: string;
  valueLength: number;
  withLightBg?: boolean;
};

export const OtpField = ({
  error,
  onChange,
  value,
  valueLength,
  withLightBg,
}: OtpFieldProps) => {
  const {
    valueItems,
    firstNumberInput,
    handleInputChange,
    handleKeyDown,
    handleFocus,
  } = useOtpInput({
    value,
    valueLength,
    onChange,
  });

  return (
    <div className="space-y-4">
      <div className="flex w-full gap-2.5">
        {valueItems.map(({ digit, position }) => (
          <OtpDigit
            digit={digit}
            firstInputRef={position === 0 ? firstNumberInput : undefined}
            index={position}
            key={`otp-digit-${position}`}
            onChange={handleInputChange}
            onFocus={handleFocus}
            onKeyDown={handleKeyDown}
            valueLength={valueLength}
            withLightBg={withLightBg}
          />
        ))}
      </div>
      {isTruthy(error) && (
        <ValidationErrorText dataTestId={error}>{error}</ValidationErrorText>
      )}
    </div>
  );
};
